import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'
import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'
import { AdsFAQ } from 'src/Components/AdsFAQ'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { HelmetTitle } from '../../Components/HelmetTitle'
import { SelectAdsStrategy } from '../ArtistRegisterPageMetaAds/Components/SelectStrategy'
import { CreateCampaignBreadcrumbsNoAuthAds } from '../../Components/CreateCampaignBreadcrumbsNoAuthAds'

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
  }
`

export const CreateAdsNoAuth: FC = () => {
  const navigate = useNavigate()

  const handleSelectStrategy = (strategy: AdCampaignStrategyEnum): void => {
    navigate(`${PublicRoutesEnum.CreateAdsCampaign}/${strategy}`)
  }

  return (
    <NoAuthPageLayout>
      <HelmetTitle />
      <Container>
        <CreateCampaignBreadcrumbsNoAuthAds />
        <SelectAdsStrategy onSelectStrategy={handleSelectStrategy} />
        <AdsFAQ />
      </Container>
    </NoAuthPageLayout>
  )
}
